<div class="bundle-settlements-detail">
  <div class="bundle-settlements-detail-header" data-cy="bundle-settlements-detail-header">
    <span class="label" data-cy="bundle-settlements-detail-complaint-label">{{labelComplaintNumber}}</span>
    <span class="value complaint"
    data-cy="bundle-settlements-detail-complaint-value">{{$safeNavigationMigration(bundleSettlementDetailData?.complaintCode) | undefinedValue}}</span>
    <span class="label" data-cy="bundle-settlements-detail-settlement-label">{{labelSettlementNumber}}</span>
    <span class="value"
    data-cy="bundle-settlements-detail-settlement-value">{{$safeNavigationMigration(bundleSettlementDetailData?.settlementCode) | undefinedValue}}</span>
  </div>

  <div class="bundle-settlements-section-title"
  data-cy="bundle-settings-section-title-detail-information">{{titleDetailInformation}}</div>

  <div class="bundle-settlements-detail-information">
    <app-input-dropdown
      [initialValue]="$safeNavigationMigration(bundleSettlementDetailData?.material) | prettyPrintMaterialNumber | undefinedValue"
      [showViewMode]="true"
      baseCypressTag="bundle-settlements-detail-material"
      label="Part NO. / Part description">
    </app-input-dropdown>
    <app-input-dropdown
      [initialValue]="retrieveShipToPartyPipe($safeNavigationMigration(bundleSettlementDetailData?.shipToParty)) | undefinedValue"
      [showViewMode]="true"
      baseCypressTag="bundle-settlements-detail-shipToParty"
      label="Ship to party">
    </app-input-dropdown>
    <app-input-dropdown
      [initialValue]="$safeNavigationMigration(bundleSettlementDetailData?.customerComplaintNumber) | undefinedValue"
      [showViewMode]="true"
      baseCypressTag="bundle-settlements-detail-customer-complaint"
      label="Customer complaint NO.">
    </app-input-dropdown>
    <app-input-dropdown
      [initialValue]="$safeNavigationMigration(bundleSettlementDetailData?.supplier) | prettyPrintReference | undefinedValue"
      [showViewMode]="true"
      baseCypressTag="bundle-settlements-detail-supplier"
      label="Supplier">
    </app-input-dropdown>
  </div>

  <div class="bundle-settlements-detail-description">
    <app-input-textarea
      [height]="88"
      [initialValue]="$safeNavigationMigration(bundleSettlementDetailData?.complaintDescription) | undefinedValue"
      [showViewMode]="true"
      baseCypressTag="bundle-settlements-detail-complaint-description"
      label="Complaint description">
    </app-input-textarea>
  </div>

  <div class="bundle-settlements-section-title"
  data-cy="bundle-settings-section-title-detail-agreement">{{titleDetailAgreement}}</div>

  <div data-cy="bundle-settlements-detail-table-wrapper">
    <app-table [tableData]="tableData" [tableName]="titleDetailAgreementTable"></app-table>

    <div class="bundle-settlements-detail-table-total">
      @if (isBundleTypeTeMinutes) {
        <div class="bundle-settlements-detail-table-total-text"
        data-cy="bundle-settlements-detail-table-total-0">{{labelTotal}} {{financialNumberPipe(bundleSettlementDetailData.teMinutesTotalCost, bundleSettlementDetailData.currency)}}</div>
      }
      @if (isBundleTypePartsBundling) {
        <div class="bundle-settlements-detail-table-total-material">
          <div class="bundle-settlements-detail-table-total-text">
            <span data-cy="bundle-settlements-detail-table-total-0">{{labelTotal}} {{financialNumberPipe(bundleSettlementDetailData.materialsTotalNetCost, bundleSettlementDetailData.currency)}}</span>
          </div>
          <div class="bundle-settlements-detail-table-total-text">
            <span data-cy="bundle-settlements-detail-table-total-1">{{labelTotal}} {{financialNumberPipe(bundleSettlementDetailData.materialsTotalGrossCost, bundleSettlementDetailData.currency)}}</span>
          </div>
        </div>
      }
    </div>

    <div class="bundle-settlements-detail-separator"></div>
  </div>

  <ng-template #commentTableBundlesTemplate let-commentIsNull="commentIsNull" let-commentTooltip="commentTooltip"
    let-commentValue="commentValue">
    <div class="bundle-settlements-detail-comment-wrapper" data-cy="bundle-settlements-detail-comment-wrapper">
      <app-tooltip [dynamic]="false" message="{{commentTooltip}}">
        <app-flying-menu [isDisable]="commentIsNull">
          <div class="bundle-settlements-detail-comment-icon" labelFlyingMenu>
            <span class="iwp-icon-gen_comment"></span>
          </div>
          <div class="bundle-settlements-detail-comment-content-wrapper" contentFlyingMenu>
            <div class="bundle-settlements-detail-comment-label"
            data-cy="bundle-settlements-detail-comment-label">{{labelCommentFlyingMenu}}</div>
            <div class="bundle-settlements-detail-comment-content"
            data-cy="bundle-settlements-detail-comment-content">{{commentValue}}</div>
          </div>
        </app-flying-menu>
      </app-tooltip>
    </div>
  </ng-template>
</div>

